const loginSiteHeaderTemplate = `
<span class="site-logo-wrapper">
    <a ui-sref="home">
        <img
            src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
            class="site-logo"
            alt="{{accuLogoAltAttribute}}"
        />
    </a>
</span>
<header-no-login accu-customization="accuCustomization" urls="urls" />
`;
export default loginSiteHeaderTemplate;
